import React from 'react';
import styles from './PostList.module.scss';
import classNames from 'classnames/bind';
import PostItem from './PostItem';
import { NavLink } from 'react-router-dom';
import routes from '~/configs';
import TitleComp2 from '../TitleComp2';

const cx = classNames.bind(styles);

function PostList({ refE, title = '', type = 'row', posts = [], animation }) {
  return (
    <div className={cx('post-container', { animation })}>
      <TitleComp2>{title === '' ? 'Bài viết' : title}</TitleComp2>
      <div ref={refE} className={cx('post-list', { col: type === 'col', 'fade-in': title !== '' })}>
        {posts &&
          posts.map((post, index) => (
              <PostItem key={index} post={post} />
          ))}
      </div>

      {title === '' ? (
        <NavLink to={routes.post} className={cx('see-more')}>
          Xem thêm
        </NavLink>
      ) : (
        ''
      )}
    </div>
  );
}

export default PostList;
